import { ILog, Log } from "./Log";
import { TelemetryFn } from "./TelemetryFn";

export interface ILogFactory {
  getLog(key: string): ILog;
}

export class LogFactory implements ILogFactory {
  public constructor(private telemetryFn: TelemetryFn) {}

  public getLog(key: string) {
    return new Log(this.telemetryFn, key);
  }
}
